module.exports = __webpack_public_path__ + "f7323dbc1526a16e19fcab7897d2cda9.png";